import { useContext } from 'react';
import ABSegmentContext from '../../components/ab-segment-context';

const useEnabledSegment = (segment: string): boolean => {
  const segments = useContext(ABSegmentContext);

  return segments[segment] === 'a';
};

export default useEnabledSegment;
